export const prepareTransportationRows = (row) => {
  const {
    content,
    status,
    driver,
    vehicle,
    startPoint,
    endPoint,
    totalDuration,
    totalDistance,
    beginDate,
    endDate,
  } = row?.transportation;
  const localizationStatus = status === 'SUCCESSFUL' ? 'BAŞARILI' : 'BAŞARISIZ';
  return {
    content: `${content || '-'}`,
    status: `${localizationStatus || '-'}`,
    driver: `${driver?.id || '-'}`,
    vehicle: `${vehicle?.id || '-'}`,
    startPoint: `${startPoint || '-'}`,
    endPoint: `${endPoint || '-'}`,
    totalDuration: `${Math.round(totalDuration / 60) || '0'}`,
    totalDistance: `${Math.round(totalDistance / 1000) || '0'}`,
    beginDate: `${new Date(beginDate).toLocaleString('tr')}`,
    endDate: `${endDate ? new Date(endDate).toLocaleString('tr') : '-'}`,
  };
};
